import { FundNameData, FundNameNjBestData, ProductData } from '@types';
import { AgGridHelperService } from '@products/fund-listing/services/ag-grid-helper.service';
import { Component } from '@angular/core';
import { EMDASH } from '@products/utils/constants/product.constants';
import { ICellRendererParams } from '@ag-grid-community/core';
import { Logger } from '@utils/logger';
import get from 'lodash/get';
import { NotificationTypes } from '@accounts/accounts-alerts/accounts-alerts.interface';

const logger = Logger.getLogger('FundNameNjBestCellRendererComponent');

@Component({
  selector: 'ft-fund-name-njbest-cell-renderer',
  templateUrl: './fund-name-njbest-cell-renderer.component.html',
})
export class FundNameNjBestCellRendererComponent {
  isSiteIntl: boolean;
  fundDetail: FundNameNjBestData;
  fundLink: string;
  showSalesCharges: boolean;
  showPerformanceAndMaintananceCharges: boolean;
  maxIntialSalesCharge: string;
  performanceCharge: string;
  maintananceCharge: string;
  cdsc: string;
  isSoftLaunch: boolean;
  ppssMessage: string;
  ppssTooltip: string;
  // notificationType: NotificationTypes;

  showTooltipAtTop: boolean;
  constructor(private agGridHelper: AgGridHelperService) {}

  agInit(params: ICellRendererParams) {
    const product: ProductData = params.data;
    this.showSalesCharges = get(params, 'showSalesCharges', true);
    this.fundDetail = this.agGridHelper.getFundDetailNjBest(product);

    const salesCharge = product.shareClass?.charges?.maxIntialSalesCharge;
    const cdscValue = product.shareClass?.charges?.cdsc;

    this.maintananceCharge = product.shareClass?.charges?.maintananceCharge;
    this.performanceCharge = product.shareClass?.charges?.performanceFeeCharge;

    if (salesCharge !== EMDASH && cdscValue !== EMDASH) {
      this.maxIntialSalesCharge = salesCharge;
      this.cdsc = cdscValue;
    } else {
      this.showSalesCharges = false;
    }

    this.isSoftLaunch = product.shareClass?.isSoftLaunch;
    this.fundLink = product.shareClass?.link;
  }
}
